import { WIDGET_URL_REQUEST, WIDGET_URL_SUCCESS } from "../actions/widget";

const initialState = {
	fetching: false,
	url: null,
	groupName: null,
};

const widget = (state = initialState, action) => {
	switch (action.type) {
		case WIDGET_URL_REQUEST:
			return { ...state, fetching: true };
		case WIDGET_URL_SUCCESS:
			return { ...state, fetching: false, url: action.url, groupName: action.groupName };
		default:
			return state;
	}
};

export default widget;
